<template>
  <main class="md:mx-14 mx-4">
    <app-tour
      :tourDetails="bulkPayoutTour"
      tourComponent="bulkPayout"
      :displayTour="displayTour"
      @stopTour="stopTour"
    />
    <initiate-tour-button
      @startTour="startBulkPayoutTour"
      v-if="isDefaultBulkPayoutScreen"
    />
    <component :is="activeComponent" />
  </main>
</template>

<script>
import { BULK_PAYOUT_TOUR } from '@/utils/constants'
import fetchAllTours from '@/mixins/appTourApi.js'
export default {
  mixins: [fetchAllTours],
  components: {
    AppTour: () => import('@/components/v2/app-tour/AppTour.vue'),
    InitiateTourButton: () =>
      import('@/components/v2/app-tour/InitiateTourButton.vue'),
    BulkPayoutOverview: () =>
      import('@/components/v2/bulkPayout/layouts/BulkPayoutOverview.vue'),
    BulkPayoutForm: () =>
      import('@/components/v2/bulkPayout/layouts/BulkPayoutForm.vue')
  },
  data () {
    return {
      displayTour: false,
      bulkPayoutTour: BULK_PAYOUT_TOUR
    }
  },
  computed: {
    activeComponent () {
      return this.$store.state.bulkPayout.activeComponent
    },
    isANewUser () {
      return !this.$store.state.appTour.allTours.bulkPayout
    },
    isDefaultBulkPayoutScreen () {
      return this.activeComponent === 'bulk-payout-overview'
    }
  },
  methods: {
    startBulkPayoutTour () {
      this.$tours.bulkPayout.start()
      this.displayTour = true
    },
    stopTour () {
      this.displayTour = false
    },
    changeComponent (name) {
      this.activeComponent = name
    },
    async startTourForANewUser () {
      await this.fetchAllTours()
      if (this.isDefaultBulkPayoutScreen && this.isANewUser) {
        this.startBulkPayoutTour()
      }
    }
  },
  async mounted () {
    await this.startTourForANewUser()
  }
}
</script>
